var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C6C6C6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "credit-card-solid",
    className: "st0",
    d: "M14.74,14.74c-5.56,0-10.07,4.51-10.07,10.07v5.04h90.67v-5.04 c0-5.56-4.51-10.07-10.07-10.07H14.74z M95.34,44.96H4.66v30.22c0,5.56,4.51,10.07,10.07,10.07h70.52c5.56,0,10.07-4.51,10.07-10.07 V44.96z M22.29,65.12h10.07c1.39,0,2.52,1.13,2.52,2.52s-1.13,2.52-2.52,2.52H22.29c-1.39,0-2.52-1.13-2.52-2.52 S20.9,65.12,22.29,65.12z M39.92,67.64c0-1.39,1.13-2.51,2.52-2.52h20.15c1.39,0,2.52,1.13,2.52,2.52s-1.13,2.52-2.52,2.52l0,0 H42.44C41.05,70.15,39.93,69.02,39.92,67.64L39.92,67.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.b40116ef027df1d4aabdbcb29713af76.svg";
export { ForwardRef as ReactComponent };